import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import List, { ListItem, ListItemIcon, ListItemText } from '@material-ui/core/List'
import Typography from '@material-ui/core/Typography'
import Toolbar from '@material-ui/core/Toolbar'

const style = theme => ({
  flex: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around'
  },
  item: {
    
  },
  icon: {
    paddingRight: '20px'
  },
  row: {
    display: 'block'
  }
})

const ItemSummary = ({ classes, title, value, label, data}) => {
  if (!data) {
    return null
  }
  
  return (
    <div>
      {Object.keys(data).map(key => {
        const title = key
        const value = data[key]
        return (
          <div className={classes.flex} >
            <div className={classes.item}><Typography>{title}</Typography></div>
            <div className={classes.item}><Typography>{value}</Typography></div>
          </div>
        )})}
    </div>
  )
}



export default withStyles(style)(ItemSummary)



// WEBPACK FOOTER //
// ./src/components/MopraSummary.js